// MastiBazaar app-wide constants.
//
// Admin auth has moved to the backend (FastAPI + bcrypt + JWT). The frontend
// only knows the admin route and the magic-click config — the password is
// validated server-side via POST /api/auth/login.
export const ADMIN_EMAIL = "admin@mastibazaar.in";

// Secret admin route. Not linked anywhere visible — reachable only by:
//  1. Typing the URL directly
//  2. The "magic click" easter egg in the header (5 quick clicks on the logo)
export const ADMIN_ROUTE = "/masti-backdoor-99x7";

// Magic-click trigger config
export const MAGIC_CLICK_COUNT = 5;
export const MAGIC_CLICK_WINDOW_MS = 1500;

export const CATEGORIES = [
  "Fashion",
  "Beauty",
  "Home",
  "Tech",
  "Wellness",
  "Accessories",
  "General",
];
